var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { createContext, useEffect, useLayoutEffect, useRef, useState, useContext } from 'react';
import { useSubmit } from './Submit';
import { useCustomJson } from './CustomJson';
var FramePayContext = createContext({
    framePayEnabled: false,
    initialized: false,
});
export function FramePay(_a) {
    var _this = this;
    var children = _a.children, framePayEnabled = _a.framePayEnabled;
    var handleCheckout = useSubmit().handleCheckout;
    var _b = useCustomJson(), customJson = _b.customJson, getCustomJson = _b.getCustomJson;
    var setFramePayToken = function (data, extraData) { return __awaiter(_this, void 0, void 0, function () {
        var billingAddress, email, phone, variables, shippingAddress;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        return __generator(this, function (_l) {
            switch (_l.label) {
                case 0:
                    console.log({ data: data, extraData: extraData });
                    billingAddress = data === null || data === void 0 ? void 0 : data.billingAddress;
                    email = (_c = (_b = (_a = billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.emails) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : extraData.emailAddress) !== null && _c !== void 0 ? _c : '';
                    phone = (_e = (_d = billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.phoneNumbers) === null || _d === void 0 ? void 0 : _d[0]) !== null && _e !== void 0 ? _e : '';
                    variables = {
                        paymentToken: data.id,
                        billing: {
                            country: (_f = billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.country) !== null && _f !== void 0 ? _f : '',
                            postalCode: (_g = billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.postalCode) !== null && _g !== void 0 ? _g : '',
                            address: '',
                            city: '',
                            region: '',
                        },
                        customer: {
                            firstName: (_h = billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.firstName) !== null && _h !== void 0 ? _h : '',
                            lastName: (_j = billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.lastName) !== null && _j !== void 0 ? _j : '',
                            email: email,
                            phone: phone,
                        },
                        customJson: __assign(__assign({}, customJson), getCustomJson()),
                    };
                    shippingAddress = (_k = extraData === null || extraData === void 0 ? void 0 : extraData.shippingDetails) === null || _k === void 0 ? void 0 : _k.address;
                    if (shippingAddress) {
                        variables.shipping = {
                            country: shippingAddress.countryCode || '',
                            postalCode: shippingAddress.postalCode || '',
                            address: shippingAddress.address1 || '',
                            address2: shippingAddress.address2 || '',
                            city: shippingAddress.locality || '',
                            region: shippingAddress.administrativeArea || '',
                        };
                    }
                    return [4 /*yield*/, handleCheckout(variables)];
                case 1:
                    _l.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    if (!framePayEnabled)
        return _jsx(_Fragment, { children: children });
    return (_jsx(FramePayProvider, __assign({ onSuccess: setFramePayToken, framePayEnabled: framePayEnabled }, { children: children })));
}
export function FramePayProvider(_a) {
    var children = _a.children, onSuccess = _a.onSuccess, _b = _a.framePayEnabled, framePayEnabled = _b === void 0 ? false : _b;
    var _c = useState(false), initialized = _c[0], setInitialized = _c[1];
    var ref = useRef(onSuccess);
    useLayoutEffect(function () {
        initializeFramePay()
            .then(function () {
            setInitialized(true);
            window.Rebilly.on('token-ready', function (data, extraData) {
                // At this point you can use the token for other operations
                // for example to create a payment instrument or transaction
                ref.current(data, extraData);
            });
        })
            .catch(function (err) {
            console.log('Error initializing frame pay', err);
        });
    }, []);
    useEffect(function () {
        ref.current = onSuccess;
    }, [onSuccess]);
    return _jsx(FramePayContext.Provider, __assign({ value: { initialized: initialized, framePayEnabled: framePayEnabled } }, { children: children }));
}
var initializing;
function initializeFramePay() {
    if (initializing)
        return initializing;
    initializing = Promise.all([
        appendScript('https://framepay.rebilly.com/rebilly.js'),
        appendLink('https://framepay.rebilly.com/rebilly.css'),
    ]);
    return initializing;
}
function appendScript(src) {
    return new Promise(function (res, rej) {
        var script = document.createElement('script');
        script.src = src;
        script.onload = function () { return res(); };
        script.onerror = function (e) { return rej(e); };
        document.body.appendChild(script);
    });
}
function appendLink(href) {
    return new Promise(function (res, rej) {
        var link = document.createElement('link');
        link.href = href;
        link.rel = 'stylesheet';
        link.onload = function () { return res(); };
        link.onerror = function (e) { return rej(e); };
        document.head.appendChild(link);
    });
}
export var useFramePay = function () {
    var context = useContext(FramePayContext);
    if (!context)
        throw new Error('FramePayProvider not found in root or is not enabled');
    return context;
};
//# sourceMappingURL=FramePay.js.map